import BasicLoginConfigForm from "./BasicLoginConfigForm";
import { UPDATE_BASIC_LOGIN_CONFIG } from "./query";

const UpdateBasicLoginConfig = ({ data }) => {
    const {
        id,
        appName,
        domainName,
        rootPath,
        basicAuthPath,
        forogtPasswordPath,
        resetPasswordPath,
        changePasswordPath,
        isEnabled,
        country,
    } = data;

    const updateData = {
        id,
        appName,
        basicLoginDomainName: domainName,
        basicLoginRootPath: rootPath,
        basicAuthPath,
        forogtPasswordPath,
        resetPasswordPath,
        changePasswordPath,
        isEnabled,
        country,
    };

    return (
        <>
            <h5 className="mb-3">Update Basic Login Config</h5>

            <BasicLoginConfigForm
                query={UPDATE_BASIC_LOGIN_CONFIG}
                formType="update"
                formData={updateData}
            />
        </>
    );
};

export default UpdateBasicLoginConfig;
